module.exports = __webpack_public_path__ + "img/img_covertack_star.66bbbad6.png";